<script setup>
import {computed, ref, watchEffect} from 'vue'
import {useItemDataStore} from '@/stores/itemData' // Adjust import path as needed

const props = defineProps({
    item: {
        type: Object,
        default: () => ({})
    },
    value: Number
})

const itemDataStore = useItemDataStore()

const customerId = computed(() => props.value)
const customerName = ref('')

// Watch for changes to customerId and perform the async fetch
watchEffect(async () => {
    if (!customerId.value) {
        customerName.value = ''
        return
    }

    try {
        const customer = await itemDataStore.get({
            tableName: 'm_registrants_registrants',
            id: customerId.value
        })

        customerName.value = customer ? `${customer.firstName} ${customer.lastName}` : ''
    } catch (error) {
        console.error('Failed to fetch customer name:', error)
        customerName.value = ''
    }
})

const name = computed(() => {
    if (props.item?.firstName) {
        return `${props.item.firstName} ${props.item.lastName}`
    }

    return customerName.value
})
</script>

<template>
    <span>{{ name }}</span>
</template>